<template>
  <apollo-query :query='listRemoteAnimations'
                fetch-policy='cache-and-network'
                :update='onUpdate'
                :debounce='800'
                :variables='{cursor,size:search === "" ? size : size,search}'>
    <template v-slot='{ result: { loading, error, data }, isLoading, query }'>

      <loading v-if='isProcessing'>
        <p class="text-black text-lg font-semibold">Processing animation...</p>
        <p class="text-gray-700 text-xs">Brought to you by gfycat.com</p>
        <p class="text-black mb-2">This may take up to a minute.</p>
      </loading>

      <div class="relative mx-4 my-2">
        <span v-if='isLoading' class="apollo-spinner text-green-500" />
        <magnify v-else :size='32' class="apollo-search left-0 " />
        <input type="search"
               class="w-full m-1 bg-purple-white shadow rounded border-0 p-3 pl-10"
               placeholder="Search stickers..."
               @input='(evt)=> { search=evt.target.value; }'
               :value='search' >
      </div>

      <div class="flex flex-row flex-wrap flex-none">
        <button v-for='related in (((data||{}).listRemoteAnimations||{}).related||[]).slice(0,15)' :key='related' class="px-2 mx-1 h-6 bg-blue-600 text-white rounded-lg text-sm my-1" @click='search = related'>
          {{related}}
        </button>
      </div>

      <div class="w-full text-xs text-gray-600 text-right"><span class="text-right">brought to you by gfycat.com</span></div>

      <div v-if='isLoading' class="spinner text-3xl mt-8 mb-4" />

      <pbc-error v-if='error'
                 :retry='true'
                 @retry='query.refetch()'
                 message="There was a snag loading animations. Please retry." />

      <div class="grid grid-cols-3 gap-1">
        <button v-for='animation in (((data||{}).listRemoteAnimations||{}).items||[])'
                :key='animation.webpUrl'
                style='background-color: #313131'
                @click='onSelect(animation)'
                class="flex items-center justify-center">
          <img class='align-center object-contain h-32' :src='!isSafari ? animation.webpUrl : animation.gifUrl' loading="lazy" />
        </button>
      </div>
      <load-more v-if='(((data||{}).listRemoteAnimations||{}).items||[]).length > 5' @load-more='onLoadMore(query, data, $event)' />

        <pbc-error v-if='processingError'
                   :retry='true'
                   @retry='processingError = ""'
                   message="That's our whoops. Cannot process animation. Please try again or choose another."
                   :error='processingError'
                   >
        </pbc-error>
    </template>
  </apollo-query>
</template>
<script>
import ImportHelper from '@/ui/importhelper.js';
import UAParser from 'ua-parser-js';

import Magnify from '@icons/Magnify.vue';
import LoadMore from '@ui/atoms/LoadMore.vue';
import { listRemoteAnimations } from '@/gql/Queries.js';
import { uniqBy } from 'lodash';
import { mapState } from 'vuex';
export default {
  inject:['api'],
  props:{
  },
  data() {
    const uaparser = new UAParser();
    const isSafari = uaparser.getBrowser().name.toLowerCase().includes('safari');
    const search = this.$store.state.stickerSearch;
    const importHelper = new ImportHelper(this.api, this.$apollo);
    return {
      listRemoteAnimations,
      isSafari,
      isProcessing: false,
      size:30,
      cursor:undefined,
      search,
      lastSearch:search,
      processingError: '',
      existingAnimations: [],
      importHelper
    }
  },
  components: {
    LoadMore,
    Magnify
  },
  beforeDestroy() {
    this.importHelper.destroy();
  },
  methods: {
    onUpdate(data) {

      console.log('LS, search', this.lastSearch, this.search);
      if (this.lastSearch !== this.search) {
        this.lastSearch = this.search;
        this.existingAnimations = [];
        console.log('return data');
        return data;
      }
      const newAnimations = this.mergeAnimations(this.existingAnimations || [], data.listRemoteAnimations.items);
      this.existingAnimations = newAnimations;

      data.listRemoteAnimations.items = newAnimations;

      this.lastSearch = this.search;

      this.$store.commit('setStickerSearch', this.search);

      if (this.search !== '') {
        this.$ana.track({
          eventCategory:'search',
          eventAction:'stickers',
          extra:{
            search:this.search
          }
        });
      }

      return data;
    },
    mergeAnimations(previous, fetchMore) {
      const items = [...previous, ...fetchMore];
      return uniqBy(items, ({webpUrl}) => {
        return webpUrl;
      });
    },
    async onLoadMore(query, data, $loadMore) {
      console.log('have data', data);

      const cursor = data.listRemoteAnimations.cursor;
      console.log('incoming cursor', cursor);
      $loadMore.setLoading(true);
      const self = this;
      const fetchedMore = await query.fetchMore({
        variables:{
          cursor,
          size:this.size,
          search:this.search
        },
        updateQuery(prev, { fetchMoreResult }) {
          console.log('have prev', JSON.stringify(prev,0,2));
          console.log('FMR', fetchMoreResult);
          return Object.assign({}, prev, {
            listRemoteAnimations: {
              cursor:fetchMoreResult.listRemoteAnimations.cursor,
              //items: [...prev.listRemoteAnimations.items, ...fetchMoreResult.listRemoteAnimations.items],
              items: self.mergeAnimations(prev.listRemoteAnimations.items, fetchMoreResult.listRemoteAnimations.items),
              related: fetchMoreResult.listRemoteAnimations.related,
              __typename:prev.listRemoteAnimations.__typename
            },
            __typename:prev.__typename
          });
        }
      })
      $loadMore.setLoading(false);

      console.log('data after fetchmore', fetchedMore);
      if (fetchedMore.data.listRemoteAnimations.cursor === '') {
        $loadMore.setEnded(true);
      }
    },
    async onSelect(animation) {

      console.log('selected', animation);
      this.isProcessing = true;
      try {
        const animationData = await this.importHelper.importAnimation(animation.webpUrl);
        this.isProcessing = false;
        this.$emit('select', animationData);
      } catch (e) {
        this.isProcessing = false;
        this.processingError = 'Processing error'
        console.error('error importing', e);
      }
      //this.isProcessing = false;
      //this.isProcessing = true;
      /*
      try {
        const importData = await this.$apollo.mutate({
          mutation:this.uploadRemoteAnimation,
          variables:{
            url: animation.webpUrl
          },
          context: {
            timeout: 60 * 1000
          },
          error(error) {
            console.log('there is error', error);
            this.processingError = JSON.stringify(error.message);
            throw error;
          }
        });

        console.log('have import data', importData);
        const waitingData = await this.waitFor(importData.data.uploadRemoteAnimation.importId);

        this.isProcessing = false;
        console.log('uploadedAnimation', uploadedAnimation);
        this.$emit("select", waitingData);
      } catch (e) {
        this.isProcessing = false;
        console.error('errorzzzz', e);
        this.processingError = 'Processing error'
      }
      */
    }
  },
  computed: {
    ...mapState( ['stickerSearch'] )
  }
}
</script>
